<template>
    <div class="animated fadeIn"  v-if="isTaskLoaded()">
        <div class="row">
            <div class="col col-md-6 offset-md-3">
                <b-card>

                    <template v-if="isTaskDraft">


                        <b-form-group label="* Заголовок">
                            <input class="form-control" v-model="task.subject">
                        </b-form-group>

                        <b-form-group label="Страница на которой произошла ошибка">
                            <input class="form-control" :value="getRef">
                        </b-form-group>

                        <b-form-group label="Подробное описание">
                            <textarea class="form-control" v-model="task.info"></textarea>
                        </b-form-group>
                    </template>


                    <template v-if="!isTaskClosed && (iAmTaskOwner || iAmTaskAssignee)">

                    </template>

                    <template v-if="isTaskDraft">
                        <button class="btn btn-danger" @click="deleteTask">Удалить задачу</button> &nbsp;
                        <button class="btn btn-success" @click="saveDraft">Сохранить черновик</button> &nbsp;
                        <button class="btn btn-success" @click="saveNew" :disabled="!canCreateTask">Создать задачу</button> &nbsp;
                    </template>

                </b-card>

                <b-card>

                    <ul>
                        <li v-for="file in task.files"><a :href="file.path" target="_blank"><img :src="mimetypeicon32(file.mime_type)" :alt="file.mime_type"> {{file.original}}</a></li>
                    </ul>

                    <template v-if="!isTaskClosed" >
                        <template v-for="file,i in upload_files">
                            <b-form-group :label="i===0?'Загрузка файлов':''" >
                                <div class="input-group">
                                    <b-form-file id="file-default" v-model='upload_files[i]'
                                                 placeholder="Выберите файл..."
                                                 drop-placeholder="Кидать файло сюды..."
                                    ></b-form-file>
                                    <template v-if="upload_files.length>1">
                                        <button class="btn btn-danger btn-sm" @click="upload_files.splice(i,1)"><i class="fa fa-times"></i></button>
                                    </template>
                                </div>
                            </b-form-group>
                        </template>
                        <b-form-group description='Вы можете прикрепить один или несколько файлов к задаче'>
                            <button class="btn btn-primary btn-sm" @click="upload_files.push(null)">Добавить файл</button>
                        </b-form-group>
                        <button class="btn btn-success" @click="onUploadFiles">Загрузить файлы</button> &nbsp;
                    </template>

                </b-card>

            </div>
        </div>

    </div>
</template>

<script>
    import {CONSTANTS} from '@/constants';
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_tasks } from '@/functions_tasks.js';
    import { functions_mimetypes } from '@/functions_mimetypes';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'NsbPanelNewBug',
        components: {
            datePicker,
        },
        mixins: [functions, functions_loaders, functions_tasks, functions_mimetypes],
        data: function () {
            return {
                task_id:null,
                date:null,
                config:{
                    format: 'DD.MM.YYYY HH:mm',
                    locale: 'ru',
                    stepping:15
                },

                showCloseTaskModal:false,
                showDoneTaskModal:false,
                showOwnerDoneTaskModal:false,
                showRejectTaskModal:false,
                resolutionState: null,
                task_teamTask:null,
                upload_files:[null],
                loading:false
            }
        },
        methods: {
            taskLoaded: function () {
                if (this.is(this.task.deadline_at)) {
                    this.task.deadline_at = new Date(this.task.deadline_at);
                }
                if (this.is(this.task.wakeup_at)) {
                    this.task.wakeup_at = new Date(this.task.wakeup_at);
                }

                this.task.comment = null;
                this.task.resolution = null;
                this.task_teamTask = !!this.task.team_id;
            },
            deleteTask: function () {
                this.saveTask('deletetask', function(self){
                        self.$router.push({ path: '/tasks'})
                    },
                    this);
            },
            saveDraft: function () {
                this.saveTask('savedraft', function(self){
                    self.$router.push({ path: '/tasks'})
                }, this);
            },
            saveNew: function () {
                this.saveTask('starttask', function(self){
                    self.$router.push({ path: '/tasks'})
                }, this);
            },

            clickCloseTask: function ()     { this.showCloseTaskModal = true; },
            clickRejectTask: function ()    { this.showRejectTaskModal = true; },
            clickDoneTask: function ()      { this.showDoneTaskModal = true; },
            clickOwnerDoneTask: function () { this.showOwnerDoneTaskModal = true; },

            clickUpdateTask: function () {
                this.saveTask('updatetask', function(self){
                    self.$router.push({ path: '/tasks'})
                }, this);
            },

            closeTask: function () {
                this.saveTask('closetask', function(self){
                    self.$router.push({ path: '/tasks'})
                }, this);
            },
            checkCloseFormValidity() {
                let valid = this.$refs.closeConfirmForm.checkValidity();
                this.resolutionState = valid ? 'valid' : 'invalid';
                return valid;
            },
            handleCloseOk:function(evt) {
                evt.preventDefault();
                if (!this.checkCloseFormValidity()) {
                    return;
                }
                this.closeTask();
            },

            closeokTask: function () {
                this.saveTask('closeoktask', function(self){
                    self.$router.push({ path: '/tasks'})
                }, this);
            },
            checkOwnerDoneFormValidity() {
                let valid = this.$refs.ownerDoneForm.checkValidity();
                this.resolutionState = valid ? 'valid' : 'invalid';
                return valid;
            },
            handleOwnerDoneOk:function(evt) {
                evt.preventDefault();
                if (!this.checkOwnerDoneFormValidity()) {
                    return;
                }
                this.closeokTask();
            },


            handleRejectOk:function(evt) {
                this.saveTask('rejecttask', function(self){
                    self.$router.push({ path: '/tasks'})
                }, this);
            },

            handleDoneOk:function(evt) {
                this.saveTask('donetask', function(self){
                    self.$router.push({ path: '/tasks'})
                }, this);
            },

            actionClass: function (status) {
                if (status===CONSTANTS.TASK_STATUS_CLOSED) return 'alert-warning';
                if (status===CONSTANTS.TASK_STATUS_CREATED) return 'alert-info';
                if (status===CONSTANTS.TASK_STATUS_REJECTED) return 'alert-danger';
                if (status===CONSTANTS.TASK_STATUS_DONE) return 'alert-success';
                return 'alert-info';
            },

            onUploadFiles: function () {
                let willBeUploaded = 0;
                let formdata = new FormData();
                for (let i=0;i<this.upload_files.length; i++) {
                    if (this.is(this.upload_files[i])) {
                        formdata.append('file_'+willBeUploaded, this.upload_files[i]);
                        willBeUploaded++;
                    }
                }

                if (!willBeUploaded) {
                    alert("Файлы выберите для начала");
                    return;
                }

                this.httpPrepare();
                this.$http.post(this.apiurl('task/'+this.task.id+'/upload'), formdata, {
                    headers: { 'Content-Type': 'multipart/form-data'}
                }).then(function (response) {
                    response = this.httpSuccess(response);
                    this.resetTask().loadTask(this.task_id, this.taskLoaded);
                }, this.httpError);

            },

            taskLoaded: function () {
                if (this.is(this.task.deadline_at)) {
                    this.task.deadline_at = new Date(this.task.deadline_at);
                }
                if (this.is(this.task.wakeup_at)) {
                    this.task.wakeup_at = new Date(this.task.wakeup_at);
                }

                this.task.comment = null;
                this.task.resolution = null;
                this.task_teamTask = !!this.task.team_id;
            },

        },
        computed: {
            taskType: function() {
                return this.getTaskTypeTitleById(this.task.type_id);
            },
            taskTypeTitle: function() {
                let t =  this.taskType;
                if (!this.is(t)) { return '';}
                return t.title;
            },

            taskTypeInfo: function() {
                let t =  this.taskType;
                if (!this.is(t)) { return '';}
                return t.info;
            },

            isTaskDraft :function () {
                return this.task.status === CONSTANTS.TASK_STATUS_DRAFT;
            },

            isTaskCreated :function () {
                return  this.task.status === CONSTANTS.TASK_STATUS_CREATED ||
                    this.task.status === CONSTANTS.TASK_STATUS_REJECTED ||
                    this.task.status === CONSTANTS.TASK_STATUS_DONE;
            },

            isTaskClosed :function () {
                return this.task.status === CONSTANTS.TASK_STATUS_CLOSED;
            },

            statusTitle :function () {
                return CONSTANTS.TASK_STATUS_NAMES[this.task.status];
            },
            iAmTaskOwner: function() {
                return this.task.user_id === this.$store.state.user.id;
            },
            iAmTaskAssignee: function() {
                return this.task.assignee_id === this.$store.state.user.id;
            },
            canCreateTask: function () {
                return ((this.task_teamTask &&  this.is(this.task.team_id)) || (!this.task_teamTask &&  this.is(this.task.assignee_id))) &&
                    this.is(this.task.type_id) && this.is(this.task.subject);
            },
            getUsers: function () {
                return this.$store.state.user.company.users;
            },
            getRef: function () {
                console.log('x:', document.e_referrer)
                return document.e_referrer.path;
            }
        },
        created: function () {
            this.loadTaskTypes();
            this.loadTeams();

            this.httpPrepare();
            this.$http.post(this.apiurl('task/create')).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success')
                {
                    this.showMessageTaskCreated({title:'Задача '+response.payload.id+' создана'});
                    this.loadTask(response.payload.id, this.taskLoaded);
                }
                else {
                    console.log('response.error', response.error);
                }
            }, this.httpError);


        },
        watch: {
            task_teamTask : function() {
                this.task.teamTask = this.task_teamTask;;

            },
        },
        notifications: {
            showMessageTaskCreated:
                {
                    type: 'success',
                    title: 'Задача создана',
                    message: 'Задача была успешно создана, теперь вы можете перейти к ее редактированию'
                },
        },
    }
</script>
